"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEAM_BOARD_NUM_NODES_LIMIT = exports.FREE_PLAN_NUM_NODES_LIMIT = exports.CLUB_TOKEN_ADD_ON_INFO = exports.CLUB_LIMIT_ADD_ON_INFO = exports.CLUB_OFFER_PLAN_INFO = void 0;
exports.CLUB_OFFER_PLAN_INFO = {
    ['CC-001']: {
        club: 'CC-001',
        productId: 'prod_MzTJ7reVi7aBLZ',
    },
    ['CC-002']: {
        club: 'CC-002',
        productId: 'prod_QzlQdITQKVCeeW',
    },
    ['FREE-001']: {
        club: 'FREE-001',
        productId: null,
    },
    ['RUNHOB-001']: {
        club: 'RUNHOB-001',
        productId: 'prod_Ql30D9oNv9lphX',
    },
    ['RUNPRO-001']: {
        club: 'RUNPRO-001',
        productId: 'prod_QkrQyBFiY1B3G6',
    },
    ['COMFREE-001']: {
        club: 'COMFREE-001',
        productId: null,
    },
    ['COMOLD-001']: {
        club: 'COMOLD-001',
        productId: 'prod_Nu2vJwjMcSnxVI',
    },
    ['COMPRO-001']: {
        club: 'COMPRO-001',
        productId: null, // TODO: assign real Stripe productId when this plan ships (self-serve / enterprise rollout)
    },
    ['COMENT-001']: {
        club: 'COMENT-001',
        productId: null, // TODO: assign real Stripe productId when this plan ships (self-serve / enterprise rollout)
    },
    ['COMUNI-001']: {
        club: 'COMUNI-001',
        productId: null, // TODO: assign real Stripe productId when this plan ships (self-serve / enterprise rollout)
    },
};
exports.CLUB_LIMIT_ADD_ON_INFO = {
    ['LIMITFREE-001']: {
        id: 'LIMITFREE-001',
        productId: null,
    },
    ['LIMITRUNHOB-001']: {
        id: 'LIMITRUNHOB-001',
        productId: 'prod_QmeXgXme6DG2sj',
    },
    ['LIMITRUNPRO-001']: {
        id: 'LIMITRUNPRO-001',
        productId: 'prod_QmeWIPlcQ48ux3',
    },
    ['LIMITRUNPRO-002']: {
        id: 'LIMITRUNPRO-002',
        productId: 'prod_QlBkIGC6nW9DJW',
    },
    ['LIMITCOMFREE-001']: {
        id: 'LIMITCOMFREE-001',
        productId: null,
    },
    ['LIMITCOMOLD-001']: {
        id: 'LIMITCOMOLD-001',
        productId: null, // TODO: assign real Stripe productId when this plan ships (self-serve / enterprise rollout)
    },
    ['LIMITCOMPRO-001']: {
        id: 'LIMITCOMPRO-001',
        productId: null, // TODO: assign real Stripe productId when this plan ships (self-serve / enterprise rollout)
    },
    ['LIMITCOMENT-001']: {
        id: 'LIMITCOMENT-001',
        productId: null, // TODO: assign real Stripe productId when this plan ships (self-serve / enterprise rollout)
    },
    ['LIMITCOMUNI-001']: {
        id: 'LIMITCOMUNI-001',
        productId: null, // TODO: assign real Stripe productId when this plan ships (self-serve / enterprise rollout)
    },
};
exports.CLUB_TOKEN_ADD_ON_INFO = {
    ['TOKENFREE-001']: {
        id: 'TOKENFREE-001',
        productId: null,
    },
    ['TOKENRUNHOB-001']: {
        id: 'TOKENRUNHOB-001',
        productId: 'prod_QmeggHBQdw6r6S',
    },
    ['TOKENRUNPRO-001']: {
        id: 'TOKENRUNPRO-001',
        productId: 'prod_QlC5jlJcgKY5Ea',
    },
    ['TOKENRUNPRO-002']: {
        id: 'TOKENRUNPRO-002',
        productId: 'prod_Qmed1rj5GWyWrS',
    },
    ['TOKENRUNPRO-003']: {
        id: 'TOKENRUNPRO-003',
        productId: 'prod_RfM9vTdP5xysk2',
    },
    ['TOKENRUNPRO-004']: {
        id: 'TOKENRUNPRO-004',
        productId: 'prod_RoIk1zc8b3CLj8',
    },
    ['TOKENCOMFREE-001']: {
        id: 'TOKENCOMFREE-001',
        productId: null,
    },
    ['TOKENCOMOLD-001']: {
        id: 'TOKENCOMOLD-001',
        productId: null, // TODO: assign real Stripe productId when this plan ships (self-serve / enterprise rollout)
    },
    ['TOKENCOMPRO-001']: {
        id: 'TOKENCOMPRO-001',
        productId: null, // TODO: assign real Stripe productId when this plan ships (self-serve / enterprise rollout)
    },
    ['TOKENCOMPRO-002']: {
        id: 'TOKENCOMPRO-002',
        productId: null, // TODO: assign real Stripe productId when this plan ships (self-serve / enterprise rollout)
    },
    ['TOKENCOMENT-001']: {
        id: 'TOKENCOMENT-001',
        productId: null, // TODO: assign real Stripe productId when this plan ships (self-serve / enterprise rollout)
    },
    ['TOKENCOMUNI-001']: {
        id: 'TOKENCOMUNI-001',
        productId: null, // TODO: assign real Stripe productId when this plan ships (self-serve / enterprise rollout)
    },
};
/**
 * Nodes allowed on one board when the plan names no limit of its own. The real
 * cap is per-plan on `LimitClubAddOn.numNodesLimit`; this is the fallback.
 * Shared so the UI and the write that enforces it cannot disagree.
 */
exports.FREE_PLAN_NUM_NODES_LIMIT = 25;
/**
 * Nodes allowed on one TEAM board, pending team Runnit subscriptions. Separate
 * from the free-plan constant: when team plans land, this is the one that
 * changes.
 */
exports.TEAM_BOARD_NUM_NODES_LIMIT = 25;
